const myForm = $('form#contact_form')[0]
var ur = window.location.href;
var contact_form_url = 'https://myhub.remy-cointreau.com/apiproxies-shopify-webhook-uat/CRM-Case?SHOPIFY_PARAM=case-LXIII-US&AUTHORIZATION=Z7HsSHkvaYZyH1PujmEfVuUEI9GutbhuCx6iwQawZntxijlB';
if(ur.includes('https://us.louisxiii-cognac.com')) {
    contact_form_url = 'https://myhub.remy-cointreau.com/apiproxies-shopify-webhook-prod/CRM-Case?SHOPIFY_PARAM=case-LXIII-US&AUTHORIZATION=4ZzUoSdlRBmDk7qahhVtePwI2kjbODYQlFB7TA1ZGs2B9t27';
}
$('#submit-form').on('click', async (event) => {
  event.preventDefault();
  var country_code_element = document.querySelector("#country-picker");
  var country_code_selected = country_code_element.getAttribute("data-phone-code-selected");
  var phone_arr = $('#ContactFormPhone').val().split(country_code_selected);
  var phone_without_code = phone_arr["1"];
  const salutation = $('#request-title').val();
  const first_name = $('#ContactFormFirstName').val();
  const last_name = $('#ContactFormLastName').val();
  const email = $('#ContactFormEmail').val();
  const phone = phone_without_code == ''
    ? ''
    : $('#ContactFormPhone').val();
  const province = $('#country-state').val();
  const country = $('#request-country').val();
  const type = $('#request-category').val();
  const decanter_number = $('#decanter_number').val();
  const order_number = $('#order_number').val();
  const description = $('#contact-ContactFormMessage').val();
  const accepts_marketing = $('#ContactedByEmail').val();
  const phone_optin = $('#ContactedByPhone').val();
  const data_privacy = $('#agreedToDataPrivacy').val();
  const form_type = $('[name="contact[form-type]"]').val();
  const rm_program = $('#ContactFormProgram').val();
  const provinceSelect = document.querySelector('#country-state');
  const provinceName = provinceSelect.getAttribute('name');
  const provinceValue = provinceSelect.value; 
  
  var pass = true;
  if (! salutation) {
    pass = false;
    if (!$("#request-title").hasClass("error")) {
      $("#request-title").addClass("error");
      $("#request-title").parent("label").append("<span class='error-message'>Please, select your title.</span>");
    }
  }

  if (first_name == "") {
    pass = false;
    if (!$("#ContactFormFirstName").hasClass("error")) {
      $("#ContactFormFirstName").addClass("error");
      $("#ContactFormFirstName").parent("label").append("<span class='error-message'>Please, enter your first name (Louis)</span>");
    }
  }
  if (last_name == "") {
    pass = false;
    if (!$("#ContactFormLastName").hasClass("error")) {
      $("#ContactFormLastName").addClass("error");
      $("#ContactFormLastName").parent("label").append("<span class='error-message'>Please, enter your last name (Smith)</span>");
    }
  }

  if (email == "") {
    pass = false;
    if (!$("#ContactFormEmail").hasClass("error")) {
      $("#ContactFormEmail").addClass("error");
      $("#ContactFormEmail").parent("label").append("<span class='error-message'>Please, enter your email address, e.g., louissmith@gmail.com</span>");
    }
  } else if (! IsEmail($("#ContactFormEmail").val())) {
    pass = false;
    if (!$("#ContactFormEmail").hasClass("error")) {
      $("#ContactFormEmail").addClass("error");
      $("#ContactFormEmail").parent("label").append("<span class='error-message'>Please, enter a valid email address, e.g., louissmith@gmail.com</span>");
    }
  }

  if (! type) {
    pass = false;
    if (!$("#request-category").hasClass("error")) {
      $("#request-category").addClass("error");
      $("#request-category").parent("label").append("<span class='error-message'>Please, select the category.</span>");
    }
  }

  if (description == "") {
    pass = false;
    if (!$("#contact-ContactFormMessage").hasClass("error")) {
      $("#contact-ContactFormMessage").addClass("error");
      $("#contact-ContactFormMessage").parent("label").append("<span class='error-message'>Please, enter your message.</span>");
    }
  }

  if ((phone_without_code.length < 4 || phone_without_code.length > 10) && phone_optin === "true") {
    pass = false;
    if (!$("#ContactFormPhone").hasClass("error")) {
      $("#ContactFormPhone").addClass("error");
      $("#ContactFormPhone").parent().parent().append("<span id='phone-error' class='error-message'>Please, enter a valid phone number.</span>");
    }
  } else {
    $("#ContactFormPhone").removeClass("error");
    $("#phone-error").remove()
  }


  if (data_privacy === "false") {
    pass = false;
    if (!$("#agreedToDataPrivacy").is(":checked")) {
      $("#agreedToDataPrivacy").addClass("error");
      $("#agreed_data_privacy_error").removeClass('d-none');
    }
  }

  if ( $('#request-country').val() === "United States of America" || $('#request-country').val() === "China" || $('#request-country').val() === "Canada"){
    if ( !$('#country-state').val() || $('#country-state').val() === "") {
      pass = false;
      if (!$("#country-state").hasClass("error")) {
        $("#country-state").addClass("error");
        $("#country-state").parent("label").append("<span class='error-message'>Please, select the state.</span>");
      }
    }
  }

  const data = {
    salutation,
    first_name,
    last_name,
    email,
    phone,
    country,
    type,
    decanter_number,
    order_number,
    description,
    accepts_marketing: accepts_marketing === "true",
    phone_optin,
    data_privacy: data_privacy === "true",
    form_type,
    rm_program,
    ...(provinceName === 'province'
    ? { province: provinceValue }
    : provinceName === 'province_cn'
    ? { province_cn: provinceValue }
    : provinceName === 'province_cnd'
    ? { province_cnd: provinceValue }
    : {})
  }

  const url = contact_form_url;

  // Check all required fields
  if (myForm.reportValidity() && pass) { // Spinner
    $('#submit-form span').addClass('d-none')
    $('#submit-form .spinner').removeClass('d-none')

    const response = await fetch(url, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })

    const content = await response.json()

    if (content) { // If form submitted will remove the spinner and close the form
      $(".contact__header,.form-content").fadeOut(800, function() {
        repopulateStates()
        $(".success-panel").fadeIn();
        myForm.reset()
        $('#submit-form span').removeClass('d-none')
        $('#submit-form .spinner').addClass('d-none')
      })

  // $('.form-close-button').click()

      dataLayer.push({'event': 'contact_form'});

    }
  }
})